import React from 'react';
import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/projekte/finanzen', label: 'Übersicht', end: true },
  { to: '/projekte/finanzen/monat', label: 'Finanzen', end: false },
  { to: '/projekte/finanzen/dauerauftraege', label: 'Daueraufträge', end: false },
  { to: '/projekte/finanzen/jahr', label: 'Jahr', end: false },
];

/** Reiter-Navigation zwischen Vermögens-Übersicht, Monat, Daueraufträgen und Jahr. */
export default function ModulTabs() {
  return (
    <nav className="mb-6 flex gap-1 border-b border-line">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              isActive ? 'border-brand-600 text-ink' : 'border-transparent text-ink-muted hover:text-ink'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
